module.exports = __webpack_public_path__ + "img/pause_icon.e198db54.svg";